<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="loader"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >

      <div class="ml-2 mr-2">

        <!-- Table Top -->
        <b-row>

          <b-alert
            v-if="errorMsg"
            variant="warning"
            class="w-100"
            show
          >
            <h4 class="alert-heading">
              {{ $t('DEBITA_ERROR') }}
            </h4>
            <div class="alert-body">
              <span>{{ errorMsg }}</span>
            </div>
          </b-alert>

          <!-- button -->
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="float-right mb-1 w-15"
            block
            @click="postFile"
          >
            {{ $t('DEBITA_POST') }}
          </b-button>
          <b-table
            ref="refUserListTable"
            class="position-relative"
            :items="entries"
            responsive
            :fields="tableColumns"
            primary-key="id"
            show-empty
            empty-text="No matching records found"
            :tbody-tr-class="rowClass"
          >
            <template #cell(#)="data">
              {{ data.index + 1 }}
            </template>
            <template #cell(account)="data">
              <!-- Input -->
              <b-form-group>
                <v-select
                  v-model="data.item.paymentAccountType"
                  class="payments-account-select"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="paymentAccountTypes"
                  :reduce="val => val.value"
                  :clearable="false"
                  append-to-body
                  :input-id="`payment-account-type-${data.index}`"
                  @input="valueChange(data.item, data.item.paymentAccountType)"
                />
              </b-form-group>
              <div
                v-if="data.item.paymentAccountType === 'case'"
                class="case-combo-box"
              >
                <b-form-input
                  v-model="data.item.searchQuery"
                  class="caseinput"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  placeholder="Search"
                  @keyup="toggleDropdown(data.item.searchQuery, data.item)"
                  @focusout="hideDropdown(data.item)"
                />
                <div
                  v-if="data.item.isDropdownVisible"
                  class="casedropdown"
                >
                  <div
                    v-if="(data.item.accountOptions).length < 1"
                    class="caseoption"
                  >
                    {{ "No Record..." }}
                  </div>
                  <b-overlay
                    :show="data.item.recordSearch"
                    rounded="lg"
                    opacity="0.6"
                  >

                    <div
                      v-for="(option, index) in data.item.accountOptions"
                      :key="index"
                      class="caseoption"
                      @mousedown.prevent
                      @click="selectOption(data.item, option.label, option.value)"
                    >
                      <span class="caseoption-label"> {{ option.label }}</span>
                      <br>
                      <div
                        :id="`case-details-${data.index}`"
                        class="searchQuery-details"
                      >
                        <p>
                          <strong> Case No: </strong> <span style="font-weight: bold; color: #136f66;"> {{ option.value }}</span>
                        </p>
                        <p><strong>Client:</strong> {{ option.client_name ? option.client_name : 'N/A' }}
                          <span v-if="option.client_cvrcpr">({{ option.client_cvrcpr }})</span>
                        </p>
                        <p><strong>Debtor:</strong> {{ option.debtor_name ? option.debtor_name : 'N/A' }}
                          <span v-if="option.debtor_cvrcpr">({{ option.debtor_cvrcpr }})</span>
                        </p>
                      </div>
                    </div>
                  </b-overlay>
                </div>
              </div>
              <div
                v-if="data.item.paymentAccountType === 'Invoice'"
                class="case-combo-box"
              >
                <b-form-input
                  v-model="data.item.bc_invoice_id"
                  class="invoiceInput"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  placeholder="Invoice Id"
                  @input="getInvoiceDetails(data.index, data.item.bc_invoice_id)"
                />
                <b-alert
                  v-if="data.item.account === 'Invoice' && data.item.bc_invoice_id && data.item.is_invoice_exist === false"
                  variant="warning"
                  class="mt-1"
                  show
                >
                  <div class="alert-body">
                    <span>{{ $t('DEBITA_INVOICE_NOT_FOUND') }}</span>
                  </div>
                </b-alert>
              </div>
              <div
                v-if="data.item.account !== '' && data.item.accountOptions.length > 0 && data.item.paymentAccountType === 'case'"
                :id="`case-details-${data.index}`"
              >
                Case No:{{ data.item.account }}
                <br>
                Client: {{ data.item.client_name }} <span v-if="data.item.client_cvrcpr">({{ data.item.client_cvrcpr }})</span>
                <br>
                Debtor: {{ data.item.debtor_name }} <span v-if="data.item.debtor_cvrcpr">({{ data.item.debtor_cvrcpr }})</span>
              </div>
              <small
                v-if="data.item.searchQuery === 'SKAT RETUR' && (data.item.is_court_fee && data.item.is_court_fee !== '0')"
                class="text-danger"
              >*Both court fee and skat retur can not be selected together.</small>
              <small
                v-if="data.item.caseNotSelected"
                class="text-danger"
              > Please select a case as court fee is checked.</small>
            </template>
            <template #cell(is_court_fee)="data">
              <b-form-checkbox
                v-model="data.item.is_court_fee"
                :disabled="data.item.account === 'Invoice'"
              />
            </template>
            <template #cell(amount)="data">
              {{ data.item.amount + ' ' + data.item.currency || 'DKK' }}
            </template>
            <template #cell(should_include)="data">
              <b-form-checkbox
                v-model="data.item.should_include"
              />
            </template>
          </b-table>
        </b-row>
      </div></b-overlay>
    <!-- Row Loop -->
    <b-row /></div>
</template>

<!-- eslint-disable no-param-reassign -->
<script>
import {
  BAlert,
  BRow,
  BTable,
  BFormGroup,
  BFormInput,
  BButton,
  BOverlay,
  BFormCheckbox,
  // BCard,
  // BInputGroupAppend,
} from 'bootstrap-vue'
  // import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
// import { required } from '@validations'
import axios from '@axios'
import vSelect from 'vue-select'
import router from '@/router'
// import { ValidationProvider, ValidationObserver } from 'vee-validate'
// import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import constants from '@/app-configs/constants'
import i18n from '@/libs/i18n'

export default {
  components: {
    BAlert,
    vSelect,
    BFormGroup,
    BOverlay,
    BRow,
    BButton,
    BFormInput,
    BFormCheckbox,
    BTable,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      loader: false,
      client_id: '',
      secret_id: '',
      busy: false,
      perPage: '',
      searchQuery: '',
      paymentsList: [],
      tableColumns: [
        { key: '#', label: '#' },
        {
          key: 'value_date', label: i18n.t('DEBTIA_DATE'), class: 'text-center w-35',
        },
        {
          key: 'text', label: i18n.t('DEBTIA_TEXT'), thClass: 'w-20', class: 'text-center',
        },
        {
          key: 'account', label: i18n.t('DEBTIA_ACCOUNT'), class: 'w-100 pr-0 pl-0',
        },
        {
          key: 'is_court_fee', label: i18n.t('DEBTIA_COURT_FEE'),
        },
        {
          key: 'amount', label: i18n.t('DEBTIA_AMOUNT'), class: 'text-center',
        },
        { key: 'should_include', label: i18n.t('DEBTIA_INCLUDE') },
      ],
      accountDummyOptions: [{ key: '#', sortable: true, label: '#' },
        {
          key: 'value_date', value: 'val date',
        },
        {
          key: 'text', value: 'text include',
        },
        {
          key: 'account', value: 'accnt include',
        },
        {
          key: 'is_court_fee', value: 'court fee include',
        },
        { key: 'amount', value: 'amount' },
        { key: 'should_include', value: 'include' }],
      constants,
      stopPosting: false,
      accountdummy: '',
      errorMsg: '',
      emptyfilteredData: false,
      filteredData: [{ key: '#', sortable: true, label: '#' },
        {
          key: 'value_date', value: 'val date',
        },
        {
          key: 'text', value: 'text include',
        },
        {
          key: 'account', value: 'accnt include',
        },
        {
          key: 'is_court_fee', value: 'court fee include',
        },
        { key: 'amount', value: 'amount' },
        { key: 'should_include', value: 'include' }],
      selectedItem: '',
      isDropdownVisible: false,
      options: ['Option 1', 'Option 2', 'Option 3', 'Option 4'],
      // dropdownWidth: 0,
      paymentAccountTypes: [
        {
          label: 'Case', value: 'case',
        },
        {
          label: 'Skat Retur', value: 'SKAT RETUR',
        },
        {
          label: 'Invoice', value: 'Invoice',
        },
      ],
      entries: [],
    }
  },
  watch: {
    currentPage: {
      handler() {
        this.getList()
      },
    },
  },
  created() {
    this.caseCredentials()
    const documentId = router.currentRoute.params.id
    if (documentId) {
      this.getRecords()
    } else {
      this.entries = JSON.parse(localStorage.getItem('paymententries'))
      this.entries.forEach(item => {
        item.client_name = ''
        item.client_cvrcpr = ''
        item.debtor_cvrcpr = ''
        item.debtor_name = ''
        const filteritem = item.accountOptions.filter(element => element.value === Number(item.account))
        if (filteritem.length > 0) {
          // eslint-disable-next-line no-param-reassign
          item.client_name = filteritem[0].client_name
          item.client_cvrcpr = filteritem[0].client_cvrcpr
          item.debtor_cvrcpr = filteritem[0].debtor_cvrcpr
          item.debtor_name = filteritem[0].debtor_name
          // eslint-disable-next-line no-nested-ternary
          item.paymentAccountType = item.account !== '' && item.account !== 'SKAT RETUR' ? 'case' : item.account === 'SKAT RETUR' ? 'SKAT RETUR' : null
          item.searchQuery = item.paymentAccountType === 'case' ? filteritem[0].label : ''
        } else {
          let paymentAccountType = null
          if (item.account !== '' && item.account !== 'SKAT RETUR' && item.account !== 'Invoice') {
            paymentAccountType = 'case'
          } else if (item.account === 'SKAT RETUR') {
            paymentAccountType = 'SKAT RETUR'
          } else if (item.account === 'Invoice') {
            paymentAccountType = 'Invoice'
          }
          item.paymentAccountType = paymentAccountType
        }
        if (item.account === 'Invoice' && item.bc_invoice_id === '') {
          item.is_invoice_exist = false
        } else if (item.account === 'Invoice' && item.bc_invoice_id !== '') {
          item.is_invoice_exist = true
        }
      })
    }
  },
  methods: {
    async caseCredentials() {
      this.loader = true
      axios.get('user-settings/get', { params: { module: 'debt-cases' } }).then(response => {
        const settingDetails = response.data.data
        if (settingDetails === null) {
          this.client_id = ''
          this.secret_id = ''
          this.loader = false
        } else {
          this.client_id = settingDetails.client_id
          this.secret_id = settingDetails.secret
          this.loader = false
        }
      }).catch(error => {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Setting Management',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: error.response.data.message,
          },
        })
        this.loader = false
      })
    },
    setValues(element) {
      element.client_name = ''
      element.client_cvrcpr = ''
      element.debtor_cvrcpr = ''
      element.debtor_name = ''
      if (element.account === 'Invoice') {
        element.paymentAccountType = element.account
      } else {
        const filteritem = element.accountOptions.filter(e => e.value === Number(element.account))
        if (filteritem.length > 0) {
          // eslint-disable-next-line no-param-reassign
          element.client_name = filteritem[0].client_name
          element.client_cvrcpr = filteritem[0].client_cvrcpr
          element.debtor_cvrcpr = filteritem[0].debtor_cvrcpr
          element.debtor_name = filteritem[0].debtor_name
          // eslint-disable-next-line no-nested-ternary
          element.paymentAccountType = element.account !== '' && element.account !== 'SKAT RETUR' ? 'case' : element.account === 'SKAT RETUR' ? 'SKAT RETUR' : null
          element.searchQuery = element.paymentAccountType === 'case' ? filteritem[0].label : ''
        }
      }
    },
    async getRecords() {
      try {
        const documentId = router.currentRoute.params.id
        this.loader = true
        const records = await axios.get(`/payment-interface/files/get-entries/${documentId}?perPage=100`)
        // this.loader = false
        if (records.status) {
          this.loader = false
          records.data.data.entries_data.forEach(element => {
            const newObj = { ...element }
            newObj.searchQuery = null
            newObj.isDropdownVisible = false
            newObj.recordSearch = false
            newObj.paymentAccountType = null
            newObj.caseNotSelected = false
            newObj.accountOptions = []
            if (newObj.account) {
              newObj.accountOptions.unshift(...records.data.data.caseEntries)
            }
            if (element.account === 'Invoice' && element.bc_invoice_id === '') {
              newObj.is_invoice_exist = false
            } else if (element.account === 'Invoice' && element.bc_invoice_id !== '') {
              newObj.is_invoice_exist = true
            }
            this.setValues(newObj)
            this.entries.push(newObj)
          })
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: 'List could not be fetched.',
          },
        })
      }
    },
    valueChange(item, paymentAccountType) {
      if (paymentAccountType === 'SKAT RETUR') {
        // eslint-disable-next-line no-param-reassign
        item.searchQuery = 'SKAT RETUR'
        // eslint-disable-next-line no-param-reassign
        item.account = 'SKAT RETUR'
      } else if (paymentAccountType === 'Invoice') {
        // eslint-disable-next-line no-param-reassign
        item.account = 'Invoice'
      } else {
        // eslint-disable-next-line no-param-reassign
        item.searchQuery = ''
        // eslint-disable-next-line no-param-reassign
        item.account = ''
      }
    },
    hideDropdown(item) {
      setTimeout(() => {
        const filteritem = item.accountOptions.filter(element => element.label === item.searchQuery)
        // eslint-disable-next-line no-param-reassign
        item.recordSearch = false
        // eslint-disable-next-line no-param-reassign
        item.isDropdownVisible = false
        // eslint-disable-next-line no-param-reassign
        if (filteritem.length === 0) {
          // eslint-disable-next-line no-param-reassign
          item.searchQuery = null
        }
      }, 500)
    },
    async toggleDropdown(query, item) {
      // eslint-disable-next-line no-param-reassign
      item.account = ''
      if (query.length > 3) {
        // const inputWidth = document.querySelector('.case-combo-box input').offsetWidth
        // this.dropdownWidth = inputWidth
        // eslint-disable-next-line no-param-reassign
        item.recordSearch = true
        // eslint-disable-next-line no-param-reassign
        item.isDropdownVisible = true
        const cases = await axios.get(`${constants.caseServerBaseUrl}debtiaapp/debt-cases-dropdown?searchQuery=${query}`, {
          headers: {
            secret: this.secret_id,
            clientId: this.client_id,
          },
        })
        item.recordSearch = false
        // this.loader = false
        if (cases.status) {
          // eslint-disable-next-line no-param-reassign
          item.accountOptions = cases.data.data
          // eslint-disable-next-line no-param-reassign
          item.recordSearch = false
        }
      }
      if (query.length === 0) {
        // eslint-disable-next-line no-param-reassign
        item.accountOptions = []
        // eslint-disable-next-line no-param-reassign
        item.isDropdownVisible = false
      }
    },
    selectOption(item, option, value) {
      item.client_name = ''
      item.client_cvrcpr = ''
      item.debtor_cvrcpr = ''
      item.debtor_name = ''
      const filteritem = item.accountOptions.filter(element => element.value === value)
      if (filteritem.length > 0) {
        // eslint-disable-next-line no-param-reassign
        item.client_name = filteritem[0].client_name
        item.client_cvrcpr = filteritem[0].client_cvrcpr
        item.debtor_cvrcpr = filteritem[0].debtor_cvrcpr
        item.debtor_name = filteritem[0].debtor_name
      }
      // eslint-disable-next-line no-param-reassign
      item.recordSearch = false
      // eslint-disable-next-line no-param-reassign
      item.isDropdownVisible = false
      // eslint-disable-next-line no-param-reassign
      item.searchQuery = option
      // eslint-disable-next-line no-param-reassign
      item.account = value.toString()
      // eslint-disable-next-line no-param-reassign
      item.caseNotSelected = false
    },
    postFile() {
      this.stopPosting = false
      let caseError = false
      this.entries.forEach(element => {
        if (element.is_court_fee && (element.paymentAccountType !== 'case' || (element.paymentAccountType === 'case' && element.account === ''))) {
          // eslint-disable-next-line no-param-reassign
          element.caseNotSelected = true
          caseError = true
        }
        if (!element.is_invoice_exist && element.should_include && element.paymentAccountType === 'Invoice') {
          this.stopPosting = true
        }
      })
      if (!caseError) {
        for (const element of this.entries) {
          if (element.account === 'SKAT RETUR' && element.is_court_fee) {
            this.stopPosting = true
            break
          }
        }
        if (this.stopPosting) {
          this.showAlert()
        } else {
          this.confirmText()
        }
      }
    },
    confirmText() {
      const mainObject = {
        payment_entries: [],
      }
      let isNumberOfIncludeFalse = 0
      this.entries.forEach(element => {
        let { account } = element
        if (element.account !== '' && element.account !== 'SKAT RETUR') {
          const accountArr = element.account.split(':')
          // eslint-disable-next-line no-param-reassign, prefer-destructuring
          account = accountArr[0]
        }
        const obj = {
          payment_file_id: element.payment_file_id,
          value_date: element.value_date,
          text: element.text,
          account,
          is_court_fee: element.is_court_fee,
          should_include: element.should_include,
          amount: element.amount,
          currency: element.currency || '',
          id: element.id,
          bc_invoice_id: element.bc_invoice_id,
        }
        if (!element.should_include) {
          isNumberOfIncludeFalse += 1
        }
        mainObject.payment_entries.push(obj)
      })
      if (isNumberOfIncludeFalse > 0) {
        this.$swal({
          title: 'Are you sure?',
          text: `There are ${isNumberOfIncludeFalse} number of row(s) where include is false`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(async result => {
          if (result.value) {
            this.finalPost(mainObject)
          }
        })
      } else {
        this.finalPost(mainObject)
      }
    },
    async finalPost(mainObject) {
      this.loader = true
      await axios.post('/payment-interface/files/submit', mainObject, {
        headers: {
          secret: this.secret_id,
          clientId: this.client_id,
        },
      }).then(response => {
        if (response.status) {
          // this.$refs['payments-breakdown-modal'].hide()
          localStorage.removeItem('paymententries')
          this.$router.push({ name: 'payments-list' })
        }
      }).catch(err => {
        if (err.response.data.message) {
          this.loader = false
          const msg = typeof err.response.data.message === 'string' ? err.response.data.message : err.response.data.message[0]
          this.errorMsg = msg
          this.alertErrors.push(err.response.data.message)
        }
      })
    },
    showAlert() {
      this.$swal({
        title: 'Error!',
        text: 'There are some issues with some of the rows.',
        icon: 'warning',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    /**
     * @param {any} item
     * @returns {string|undefined}
     */
    rowClass(item) {
      if (!item) return undefined
      const redColorClass = 'table-danger'
      const yellowColorClass = 'table-tableYellowColor'
      // eslint-disable-next-line consistent-return
      if (!item.account) {
        return yellowColorClass
      }
      const classes = []

      if (item.searchQuery === 'SKAT RETUR' && item.is_court_fee === true) {
        return redColorClass
      }
      if (item.isDropdownVisible) classes.push('row-dropdown-open')
      return classes.length ? classes.join(' ') : undefined
    },
    showModal() {
      this.$refs['payments-breakdown-modal'].show()
    },
    getAmountTruthy(amount) {
      const newString = String(amount)
      return newString.includes('-')
    },
    getInvoiceDetails(index, bcInvoiceId) {
      clearTimeout(this.invoiceSearchTimer)
      const entry = this.entries[index]
      if (!bcInvoiceId) {
        this.$set(entry, 'is_invoice_exist', false)
        return
      }
      this.invoiceSearchTimer = setTimeout(async () => {
        entry.account = 'Invoice'
        try {
          const records = await axios.get(`/invoice-system/invoice/search?q=${bcInvoiceId}`)
          if (records.status) {
            this.$set(entry, 'is_invoice_exist', !!records.data.data)
          }
        } catch (error) {
          this.$set(entry, 'is_invoice_exist', false)
        }
      }, 500)
    },
  },
}
</script>

  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  .custom-control.custom-checkbox {
      width: fit-content;
      margin-left: 50%;
  }

  .payments-account-select {
    background-color: white;
  }

  .w-15 {
    width: 15%;
  }

  .table-tableYellowColor {
    background-color: #f5f5b7;
  }

  .bg-white {
    background-color: white;
  }

  .case-combo-box {
    // position: relative;
    // display: inline-block;
    display: block;
    width: 100%;
  }

  .caseinput {
    padding: 5px;
    width: 200px;
    min-width:300px;
    border: 1px solid #ccc;
    width: 100%;
  }

  .casedropdown {
        // position: absolute;
    // top: 100%;
    // left: 0;
    width: 100%;
    border: 1px solid #ccc;
    // border-top: none;
    background-color: #fff;
    max-height: 200px;
    overflow-y: auto;
    border-radius: 5px;
    // z-index: 1000; /* Set a higher z-index value */
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    margin-top: 5px;
  }

  tr.row-dropdown-open td {
    overflow: visible;
    vertical-align: top;
  }

  .caseoption {
    padding: 5px;
    cursor: pointer;
    color: #333; /* Dark grey font */
  }

  .caseoption:hover {
    background-color: #f0f0f0;
  }

  .extra-length {
    height: 50px !important;
  }

  .w-35 {
    width: 35% !important;
  }

  .searchQuery-details{
      background-color:rgb(233, 231, 228);
      color: black;
      box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.1), 0 3px 2px 0 rgba(0, 0, 0, 0.06);
      padding: 5px 5px 2px 20px;
      margin: 5px 0px 0px 3px;
      border-radius: 10px;
      font-family: "Montserrat", Helvetica, Arial, serif !important;
  }
  .searchQuery-details p {
    margin-bottom: 3px;
  }
  .caseoption-label {
    font-weight: bold;
    font-size: 16px;
    padding: 5px 5px 0px 8px;
  }
  </style>
